import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGenericCard = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	overflow: "visible",
	style: { display: "block" },
	width: 13,
	height: 10,
	viewBox: "0 0 13 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Vector",
		d: "M3.5 6.5H6.5M0.875 3.5H12.125M2.5 9.5H10.5C11.6046 9.5 12.5 8.60457 12.5 7.5V2.5C12.5 1.39543 11.6046 0.5 10.5 0.5H2.5C1.39543 0.5 0.5 1.39543 0.5 2.5V7.5C0.5 8.60457 1.39543 9.5 2.5 9.5Z",
		stroke: "#090714",
		strokeLinecap: "round"
	})
});
export default SvgGenericCard;
